const isSameLocalDay = (firstDate: Date, secondDate: Date) => (
    firstDate.getFullYear() === secondDate.getFullYear()
    && firstDate.getMonth() === secondDate.getMonth()
    && firstDate.getDate() === secondDate.getDate()
);

export const getTimelineTaskStartDate = (date: Date, now = new Date()) => {
    if (isSameLocalDay(date, now)) {
        const start = new Date(now);
        start.setHours(start.getHours() + 1, start.getMinutes(), 0, 0);
        return start;
    }

    const start = new Date(date);
    start.setHours(9, 0, 0, 0);
    return start;
};
